module DdsOfficeFactory
{
	export function GetCitiesByState(state: States, successCallback: (Cities: string[]) => any, failureCallback: () => any)
	{
		const parameters = {
			state: state
		};
		$.ajax("/Api/SocialSecurity/Offices/Dds/GetDdsOfficeCitiesByState", {
      data: $.param(parameters),
      contentType: "application/json; charset=utf-8",
      dataType: "json",
      type: "GET",
      timeout: 5000,
      success: successCallback,
      error: failureCallback
    });
	}

	export function GetDdsOfficesByStateCity(state: States, city: string, successCallback: (FieldOffices: IDdsOffice[]) => any, failureCallback: () => any)
	{
		const parameters = {
			state: state,
			city: city
		};
		$.ajax("/Api/SocialSecurity/Offices/Dds/GetDdsOfficesByCityState", {
      data: $.param(parameters),
      contentType: "application/json; charset=utf-8",
      dataType: "json",
      type: "GET",
      timeout: 5000,
      success: successCallback,
      error: failureCallback
    });
	}
}